import styled from '@emotion/styled';
import { activeTheme } from "services/theme";

export const PrimarySpan = styled('span')(() => ({
    color: activeTheme().palette.primary.main
}));